import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers/';
import * as memberProfileReducers from '../reducers/member-profile.reducers';

export const getMemberProfileFeatureState = createSelector(
  fromFeature.getMemberProfileState,
  (state: fromFeature.MemberProfileState) => state.memberProfile
);

export const getMemberProfileTravellersFeatureState = createSelector(
  fromFeature.getMemberProfileState,
  (state: fromFeature.MemberProfileState) => state.memberProfile.travellers
);

export const getMemberProfileSpecialOccasionsFeatureState = createSelector(
  fromFeature.getMemberProfileState,
  (state: fromFeature.MemberProfileState) => state.memberProfile.special_occasions
);

export const getMemberProfileAddressesFeatureState = createSelector(
  fromFeature.getMemberProfileState,
  (state: fromFeature.MemberProfileState) => state.memberProfile.addresses
);

export const getMemberProfilePhoneNumberFeatureState = createSelector(
  fromFeature.getMemberProfileState,
  (state: fromFeature.MemberProfileState) => state.memberProfile.phone_numbers
);

export const getMemberProfilePaymentCardsFeatureState = createSelector(
  fromFeature.getMemberProfileState,
  (state: fromFeature.MemberProfileState) => state.memberProfile.payment_cards
);

export const getMemberProfileErrorsFeatureState = createSelector(
  fromFeature.getMemberProfileState,
  (state: fromFeature.MemberProfileState) => state.memberProfile.errors
);

export const getUserId = createSelector(getMemberProfileFeatureState, memberProfileReducers.getUserId);

export const getMemberProfileLoading = createSelector(getMemberProfileFeatureState, memberProfileReducers.getLoading);

export const getMemberProfileLoaded = createSelector(getMemberProfileFeatureState, memberProfileReducers.getLoaded);
